import { render, staticRenderFns } from "./DemoBasic.vue?vue&type=template&id=1bf1e4b9&scoped=true&"
import script from "./DemoBasic.vue?vue&type=script&lang=js&"
export * from "./DemoBasic.vue?vue&type=script&lang=js&"
import style0 from "./DemoBasic.vue?vue&type=style&index=0&id=1bf1e4b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1e4b9",
  null
  
)

export default component.exports